<script setup lang="ts">
import { ref } from 'vue';
import FsumHeader from '@/components/FsumHeader.vue';

const loading = ref(false);
</script>
<template>
    <q-layout view="hHh LpR fFf">
        <FsumHeader :toggleable-side-nav="false" />
        <q-page-container
            id="fsum-main-panel"
            class="col-10 bg-gray"
        >
            <div
                class="container"
            >
                <div class="row q-mx-auto q-my-lg q-py-lg">
                    <div class="col-lg-7 col-md-8 col-sm-10 col-12 q-mx-auto bg-white restricted-access">
                        <h1 class="header">
                            Page Not Found
                        </h1>
                        <span class="subtitle">
                            Sorry, the page you are looking for does not exist.
                        </span>
                        <div class="buttons row q-gutter-md q-pt-lg">
                            <q-btn
                                class="fsum-button-outlined"
                                label="Back"
                                no-caps
                                @click="$router.back()"
                            />
                            <q-btn
                                class="fsum-button-dark-blue"
                                label="Home"
                                no-caps
                                :loading="loading"
                                @click="loading = true; $router.push({ name: 'default' })"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </q-page-container>
    </q-layout>
</template>
<style scoped lang="scss">
#fsum-main-panel {
    min-height: 100vh;
    z-index: 1;
    padding: 24px;

    @media screen and (max-width: $breakpoint-md-min) {
        padding: 16px;
    }

    .restricted-access {
        padding: 2.5rem;

        .header {
            font-size: 2rem;
            font-weight: 400;
            line-height: 1rem;
            letter-spacing: normal;
            margin: 0.5rem 0 2rem;
        }

        .subtitle {
            font-size: 1.25rem;
            font-weight: 400;
            line-height: 1rem;

            a {
                color: var(--fsum-blue);
                font-weight: 400;
            }
        }

        @media screen and (max-width: $breakpoint-md-min) {
            padding: 1.5rem;

            .header {
                font-size: 1.5rem;
            }

            .subtitle {
                font-size: 1rem;
            }
        }

        @media screen and (max-width: $breakpoint-sm-min) {
            padding: 0.5rem;

            .header {
                font-size: 1.25rem;
            }

            .subtitle {
                font-size: 0.875rem;
            }
        }
    }
}
</style>
